const host = process.env.REACT_APP_HOST || "";

function deriveTestingHost(parentHost) {
  if (!parentHost) {
    return "";
  }
  if (parentHost.includes(".parent.")) {
    return parentHost.replace(".parent.", ".testing.");
  }
  if (parentHost.startsWith("parent.")) {
    return parentHost.replace(/^parent\./, "testing.");
  }
  return "";
}

function appOrigin(appHost) {
  if (!appHost) {
    return "";
  }
  const protocol = appHost.includes("localhost") ? "http://" : "https://";
  return protocol + appHost;
}

export const TESTING_APP_ORIGIN =
  process.env.REACT_APP_TESTING_APP_ORIGIN ||
  appOrigin(deriveTestingHost(host));
